import { render, staticRenderFns } from "./AddMenuOption.vue?vue&type=template&id=2d386d3a&scoped=true&"
import script from "./AddMenuOption.vue?vue&type=script&lang=js&"
export * from "./AddMenuOption.vue?vue&type=script&lang=js&"
import style0 from "./AddMenuOption.vue?vue&type=style&index=0&id=2d386d3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d386d3a",
  null
  
)

export default component.exports